import {Button, Div, HeaderBack, Label} from 'components';
import {Ecolors} from 'constant';
import React, {ReactNode} from 'react';
import {StyleSheet} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {navigate} from 'services';
import {useAppSelector} from 'store/hooks';
import {convertNumber, parseMultilanguage} from 'utils';

const Com = (p: {
  number: number;
  content: string;
  CompRight?: () => ReactNode;
}) => {
  return (
    <Div
      paddingVertical={15}
      paddingLeft={30}
      flexDirection="row"
      alignItems="flex-start"
      justifyContent="space-between"
      paddingRight={15}>
      <Div
        widthHeight={30}
        alignItems="center"
        justifyContent="center"
        borderRadius={30}
        backgroundColor={Ecolors.spaceColor}>
        <Label fontWeight="bold" size={18} multilanguage={false}>
          {p.number}
        </Label>
      </Div>
      <Div paddingHorizontal={15} flex={1}>
        {p?.CompRight?.() || <Label size={15}>{p.content}</Label>}
      </Div>
    </Div>
  );
};

function IntroductionModal() {
  const walletBounty = useAppSelector(state => state.asset.walletBounty);
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const size = !!currentUser.eventRewardStandingOrder ? 360 : 290;
  const {eventBounty} = walletBounty;
  return (
    <Div flex={1} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack type={2} title={`eventreward.huongdanchitiet`} />
      <ScrollView style={{flex: 1}}>
        <Div>
          <Div
            style={{position: 'absolute', left: 48, top: 55}}
            height={size - 120}
            borderColor={Ecolors.spaceColor}
            borderStyle={'dashed'}
            width={1}
            backgroundColor={Ecolors.transparent}
            borderWidth={1}
          />
          <Div>
            <Div height={30} />
            <Com number={1} content={`eventreward.intro1`} />
            <Com number={2} content={`eventreward.intro2`} />
            {!!currentUser.eventRewardStandingOrder && (
              <Com number={3} content={`eventreward.intro3`} />
            )}

            <Com
              number={!!currentUser.eventRewardStandingOrder ? 4 : 3}
              content={`eventreward.intro41`}
              CompRight={() => {
                return (
                  <Div flexDirection="column" alignItems="flex-start">
                    <Div
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="flex-start">
                      <Label size={15}>{`eventreward.intro41`}</Label>
                      <Div
                        backgroundColor={Ecolors.eventYellow}
                        paddingHorizontal={2}
                        borderRadius={20}>
                        {eventBounty && (
                          <Label
                            color={Ecolors.whiteColor}
                            multilanguage={false}
                            size={15}>
                            {`100 ${parseMultilanguage(
                              `eventreward.diemthuong`,
                            )} `}
                          </Label>
                        )}
                      </Div>
                    </Div>
                    <Div
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="flex-start">
                      <Label
                        size={11}
                        multilanguage={false}>{`(${parseMultilanguage(
                        `eventreward.tuongduong`,
                      )}`}</Label>
                      {eventBounty && (
                        <Label multilanguage={false} size={11}>
                          {` ${convertNumber(eventBounty, true)} VND)`}
                        </Label>
                      )}
                    </Div>
                    <Label size={15}>{`eventreward.content2`}</Label>
                    <Label
                      marginVertical={5}
                      size={12}>{`eventreward.content3`}</Label>
                  </Div>
                );
              }}
            />
          </Div>
        </Div>
        <Div style={{alignItems: 'center'}}>
          <Button
            style={{paddingVertical: 6}}
            paddingHorizontal={10}
            width={150}
            alignItems="center"
            justifyContent="center"
            onPress={() => {
              navigate('RegulationModal');
            }}
            borderRadius={20}
            backgroundColor={Ecolors.textColor}>
            <Label
              size={14}
              color={
                Ecolors.whiteColor
              }>{`eventreward.chitietdieukhoan`}</Label>
          </Button>
        </Div>
      </ScrollView>
    </Div>
  );
}

export default React.memo(IntroductionModal);
